import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { useTheme } from '../contexts/ThemeContext'

interface TransactionCancelledModalProps {
  open: boolean
  onClose: () => void
  title?: string
  message?: string
}

export default function TransactionCancelledModal({
  open,
  onClose,
  title = 'Transaction Cancelled',
  message = 'You cancelled the transaction in MetaMask.',
}: TransactionCancelledModalProps) {
  const { colors } = useTheme()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: colors.background,
          border: `2px solid ${colors.primary}`,
          boxShadow: `0 0 20px ${colors.primaryShadow}`,
          minWidth: '400px',
        },
      }}
    >
      <DialogTitle
        sx={{
          color: colors.primary,
          textShadow: `0 0 10px ${colors.primaryShadow}`,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <CancelIcon />
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ color: colors.text, mt: 1 }}>{message}</Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: colors.primary,
            color: colors.background,
            fontWeight: 700,
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: colors.primary,
              opacity: 0.9,
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
